import React, { useMemo } from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import glassesService from "../../../services/glasses.service";

const initialValues = { discount: 0 };
const schema = Yup.object().shape({
  discount: yupSchema.discountPercent,
});
const form = [
  {
    _type: "textField",
    name: "discount",
    label: "تخفیف ٪",
    type: "number",
    inputProps: {
      min: 0,
      max: 100,
    },
  },
];
export default function SetDiscount(props) {
  const { close, data } = props;
  const errorHandler = useErrorHandler();

  const colorIds = useMemo(() => {
    const { rows, selectedRows } = data;
    const idsSet = rows.reduce((colorIds, row) => {
      if (selectedRows.includes(row.id)) {
        colorIds.add(row.glassesColorId);
      }
      return colorIds;
    }, new Set());
    return [...idsSet];
  }, [data]);

  const handleSubmit = async (model, { setSubmitting }) => {
    const { error } = await glassesService.setDiscounts({ ...model, colorIds });
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        title: "تخفیف",
        submitLabel: "ذخیره",
        schema,
        initialValues,
        handleSubmit,
        form,
      }}
    />
  );
}
